PostRender = require 'views/lib/post-render'

module.exports = (data) ->
  PostRender.enqueue ->
    window.sp? 'trackUnstructEvent:cf',
      schema: 'iglu:com.trello/debug-event/jsonschema/1-0-1'
      data: data



// WEBPACK FOOTER //
// ./app/scripts/debug/trackDebugEvent.coffee